// extracted by mini-css-extract-plugin
module.exports = {"image":"MarketingCard_image__PKU2O","container":"MarketingCard_container__ISp8j"};